// extracted by mini-css-extract-plugin
module.exports = {"header":"header_7pwJ-","logo":"logo_VkaAD","left":"left_THex8","drawer":"drawer_CGLUw","right":"right_uEZ4o","container":"container_V0pds"};